@if(isLoading) {
<div class="panel-title-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
}
@else {
<h2 class="panel-title">{{ devices?.length }} {{ 'Modules.XPACManagementComponent.XpacDevicesComponent.Title' | translate }}</h2>
<p class="p-formfield-info">{{ 'Modules.XPACManagementComponent.XpacDevicesComponent.Info' | translate }}</p>

@for(device of devices; track device) {
<app-list-item [title]="getDeviceTitle(device)" [info]="getDeviceInfo(device)">
</app-list-item>
}
}